export default {
  manage_cameraManagement_editPairing_title: "Camera Paring",
  manage_cameraManagement_editPairing_select: "Select a unit to pair with Camera",
  manage_cameraManagement_editPairing_confirmText: "Are you sure to paring/unparing this Camera?",
  manage_cameraManagement_editPairing_confirmTitle: "Paring/Unparing Camera",
  manage_cameraManagement_editPairing_pairingSuccessSave: "The camera has been successfully paired",
  manage_cameraManagement_editPairing_unPairingSuccessSave:
    "The camera has been successfully unpaired",

  manage_cameraManagement_editPairing_changeConfirmMessage:
    "The camera already has a paired unit. Are you sure you want to change the pairing?",
  manage_cameraManagement_editPairing_pairingConfirmMessage: "Are you sure to paring this camera?",
  manage_cameraManagement_editPairing_unpairingConfirmMessage:
    "Are you sure to unparing this camera?",

  manage_cameraManagement_editPairing_changeConfirmTitle: "Paring/Unparing Camera",
  manage_cameraManagement_editPairing_pairingConfirmTitle: "Paring Camera",
  manage_cameraManagement_editPairing_unpairingConfirmTitle: "Unparing Camera",
  manage_cameraManagement_editPairing_warningMessageFirst: "This unit is currently paired with",
  manage_cameraManagement_editPairing_warningMessageSecond:
    "If you continue this unit will be removed from",
  manage_cameraManagement_editPairing_warningMessageThird: "and assigned to"
};
